import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Button,
  Checkbox,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Switch,
  TextField,
} from "@mui/material";
import { MainCard } from "../../../components/surface/MainCard";
import { SectionBox } from "../../../components/surface/SectionBox";
import { useLocation, useNavigate } from "react-router-dom";
import { Formik } from "formik";
import * as Yup from "yup";
import { IMotor } from "../../../models/Configuration";
import { apiStore } from "../../../api/ApiFactory";
import CheckIcon from "@mui/icons-material/Check";
import { useNotification } from "../../../store/context/NotificationContext";
const EditMotor = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state: any = location.state;
  const { data }: { data: IMotor } = state;
  const [prerigsList, setPrerigsList] = useState([]);
  const [seriesList, setSeriesList] = useState([]);

  const { Toast } = useNotification();
  useEffect(() => {
    let mounted = true;
    if (mounted) {
      const result = apiStore.boatConfigApi.getPrerigList();
      result.then((response) => {
        setPrerigsList(response);
      });

      apiStore.boatConfigApi.getSeriesList().then((response) => {
        setSeriesList(response.data);
      });
    }
    return () => {
      mounted = false;
    };
  }, []);

  const validationSchema = Yup.object({
    name: Yup.string().max(120, "Name is to long").required("Name is required"),
    price: Yup.string()
      .required("Price is required")
      .max(120, "Name is to long"),
    horsepower: Yup.number()
      .required("Horsepower is required")
      .typeError("You must specify a number"),
    partNumber: Yup.string().required("Part Number is required"),
  });

  const initalValues: IMotor = {
    id: data?.id ? data?.id : null,
    partNumber: data?.partNumber ? data?.partNumber : "",
    name: data?.name ? data?.name : "",
    seriesMotors: data?.seriesMotors ? data.seriesMotors : [],
    price: data?.price ? data?.price : 0,
    horsepower: data?.horsepower ? data?.horsepower : 0,
    preRigs: data?.preRigs ? data?.preRigs : [],
    isActive: data?.isActive ? data?.isActive : true,
    isLooseMotorActive: data?.isLooseMotorActive
      ? data?.isLooseMotorActive
      : true,
  };

  const saveMotor = async (values: IMotor) => {
    let title = "Motor Saved Successfully.";
    try {
      const response = await apiStore.boatConfigApi.saveMotor(values);
      Toast.success({ title });
    } catch (error) {
      Toast.error({
        title: "Network Error.",
      });
    } finally {
      navigate(-1);
    }
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initalValues}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        saveMotor(values);
      }}
    >
      {({
        errors,
        handleChange,
        handleSubmit,
        getFieldProps,
        isSubmitting,
        setFieldValue,
        touched,
        values,
        status,
        handleBlur,
      }) => (
        <form onSubmit={handleSubmit}>
          <MainCard divider={true}>
            <SectionBox>
              <Grid container spacing={4}>
                <Grid item xs={6}>
                  <FormControlLabel
                    control={
                      <Switch
                        id="isActive"
                        name="isActive"
                        checked={values.isActive}
                        onChange={handleChange}
                      />
                    }
                    label="Active"
                  />
                </Grid>
                <Grid item xs={6}>
                  <FormControlLabel
                    control={
                      <Switch
                        id="isLooseMotorActive"
                        name="isLooseMotorActive"
                        checked={values.isLooseMotorActive}
                        onChange={handleChange}
                      />
                    }
                    label="isLooseMotorActive"
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={4} xl={3}>
                  <InputLabel htmlFor="name">Name *</InputLabel>
                  <TextField
                    id="name"
                    size="small"
                    placeholder="Name  *"
                    fullWidth
                    {...getFieldProps("name")}
                    error={Boolean(touched?.name && errors?.name)}
                  />
                  {touched?.name && errors?.name && (
                    <FormHelperText error id="username-helper">
                      {errors?.name}
                    </FormHelperText>
                  )}
                </Grid>
                <Grid item xs={12} md={6} lg={4} xl={3}>
                  <InputLabel>Part Number *</InputLabel>
                  <TextField
                    id="displayName"
                    size="small"
                    placeholder="Part Number *"
                    fullWidth
                    {...getFieldProps("partNumber")}
                    error={Boolean(touched?.partNumber && errors?.partNumber)}
                  />
                  {touched?.partNumber && errors?.partNumber && (
                    <FormHelperText error id="username-helper">
                      {errors?.partNumber}
                    </FormHelperText>
                  )}
                </Grid>
                <Grid item xs={12} md={6} lg={4} xl={3}>
                  <InputLabel>Price *</InputLabel>
                  <TextField
                    id="description"
                    size="small"
                    placeholder="Price *"
                    fullWidth
                    {...getFieldProps("price")}
                    error={Boolean(touched?.price && errors?.price)}
                  />
                  {touched?.price && errors?.price && (
                    <FormHelperText error id="username-helper">
                      {errors?.price}
                    </FormHelperText>
                  )}
                </Grid>
                <Grid item xs={12} md={6} lg={4} xl={3}>
                  <InputLabel>Horsepower*</InputLabel>
                  <TextField
                    id="horsepower"
                    size="small"
                    placeholder="Horsepower *"
                    fullWidth
                    {...getFieldProps("horsepower")}
                    error={Boolean(touched?.horsepower && errors?.horsepower)}
                  />
                  {touched?.horsepower && errors?.horsepower && (
                    <FormHelperText error id="horsepower">
                      {errors?.horsepower}
                    </FormHelperText>
                  )}
                </Grid>
                <Grid item xs={12} md={6} lg={4} xl={3}>
                  <InputLabel>Pre-Rig *</InputLabel>
                  <Autocomplete
                    //Key is set to dealerId in order to refresh this control if dealer choice changes.
                    multiple
                    defaultValue={data?.preRigs}
                    disablePortal
                    size="small"
                    fullWidth
                    id="preRigs"
                    disableCloseOnSelect
                    isOptionEqualToValue={(option, value) => {
                      return option.value === value.value;
                    }}
                    options={prerigsList?.length > 0 ? prerigsList : []}
                    getOptionLabel={(option: any) => option.name}
                    renderInput={(params) => (
                      <TextField {...params} name="preRigs"></TextField>
                    )}
                    onChange={(event: any, newValue) => {
                      setFieldValue("preRigs", newValue);
                    }}
                    renderOption={(props, option: any, { selected }) => (
                      <li {...props}>
                        <Checkbox
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.name}
                      </li>
                    )}
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={4} xl={3}>
                  <InputLabel>Series *</InputLabel>
                  <Autocomplete
                    multiple
                    defaultValue={data?.seriesMotors}
                    disablePortal
                    size="small"
                    fullWidth
                    id="seriesMotors"
                    disableCloseOnSelect
                    isOptionEqualToValue={(option, value) => {
                      return option.id === value.id;
                    }}
                    options={seriesList?.length > 0 ? seriesList : []}
                    getOptionLabel={(option: any) => {
                      return option.name;
                    }}
                    renderInput={(params) => (
                      <TextField {...params} name="seriesMotors"></TextField>
                    )}
                    onChange={(event: any, newValue) => {
                      setFieldValue("seriesMotors", newValue);
                    }}
                    renderOption={(props, option: any, { selected }) => (
                      <li {...props}>
                        <Checkbox
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.name}
                      </li>
                    )}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Stack
                    direction="row"
                    justifyContent="flex-end"
                    alignItems="center"
                    spacing={2}
                    sx={{ mt: 2.5 }}
                  >
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={() => navigate(-1)}
                    >
                      {" "}
                      Cancel{" "}
                    </Button>
                    <Button type="submit" variant="contained">
                      Save
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
            </SectionBox>
          </MainCard>
        </form>
      )}
    </Formik>
  );
};

export default EditMotor;
